<!-- A live HTML preview for a single menu page -->
<template>
  <tv-template-preview
    ref="current-menu-preview"
    :key="menuPageAsString"
    :fake-player-progress="false"
    :html-overlay="menuPage.menu_template.html_overlay"
    :width="tvdecoder.tvformat.width"
    :height="tvdecoder.tvformat.height"
    :max-width="previewMaxWidth"
    :max-height="previewMaxHeight"
    :duration="menuPage.menu_template.duration"
    :hide-restart-button="true"
    :hide-player-controls="true"
    :class="[elevationClass]"
    :onload-callback="
      () => populateCurrentMenuPagePreviewIframeWithOverlayData(menuPage)
    "
    :style="{
      'max-width': previewMaxWidth + 'px',
      'max-height': previewMaxHeight + 'px',
    }"
  />
</template>

<script>
import TvTemplatePreview from '@/components/TvTemplatePreview';

export default {
  components: {
    TvTemplatePreview,
  },
  props: {
    tvdecoder: {
      type: Object,
      required: true,
    },
    menuPage: {
      type: Object,
      required: true,
    },
    previewMaxWidth: {
      type: Number,
      default: 560,
    },
    previewMaxHeight: {
      type: Number,
      default: 560,
    },
    elevationClass: {
      type: String,
      default: 'elevation-3',
    },
  },
  computed: {
    tvformatAspectRatio() {
      return this.tvdecoder.tvformat.aspect_ratio;
    },
    /**
     * We use this as :key to detect changes to the menu and update the preview.
     */
    menuPageAsString() {
      return JSON.stringify(this.menuPage || {});
    },
  },
  methods: {
    populateCurrentMenuPagePreviewIframeWithOverlayData(
      menuPage,
      restartPlayer = true
    ) {
      const overlayData = {menu_page: menuPage};
      const previewWidget = this.$refs['current-menu-preview'];
      if (!previewWidget) {
        return;
      }
      previewWidget.updateOverlayData(overlayData);
      if (restartPlayer) {
        previewWidget.restartPlayer();
      }
    },
  },
};
</script>

<style scoped>
.preview-nav-button {
  position: absolute;
  bottom: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.33);
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/DecoderDetail/TvDecoderMenuPagePreview.vue